import { OnClickLink } from '../Link'
import { ParagraphSmaller } from '../Typography'

export interface DefinitionListItemProps {
  className?: string
  titleClass?: string
  dataClass?: string
  data?: string | number | JSX.Element | null
  isHidden?: boolean
  title: JSX.Element | string
  helpText?: string
  onClick?: () => void
}

export const DefinitionListItem = ({
  className = '',
  titleClass = '',
  dataClass = '',
  data,
  isHidden = false,
  title,
  helpText,
  onClick
}: DefinitionListItemProps) => {
  return isHidden ? null : (
    <div
      className={`flex flex-row first:border-t-0 border-b border-b-superSilver py-[15px] ${className}`}
    >
      <dt
        className={`w-24 sm:w-32 md:max-w-none md:w-1/2 inline-block align-top font-bold text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] text-shark ${titleClass}`}
      >
        {title}
        {helpText ? (
          <ParagraphSmaller className='!mb-0 font-normal text-anotherGrey2'>
            {helpText}
          </ParagraphSmaller>
        ) : null}
      </dt>
      <dd
        className={`flex-1 text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] text-ellipsis align-top overflow-hidden inline-block pl-10 ${dataClass}`}
      >
        {onClick ? (
          <OnClickLink onClick={onClick}>{data || '-'}</OnClickLink>
        ) : (
          data || '-'
        )}
      </dd>
    </div>
  )
}
